import React from 'react';

import { Payt as PaytIcon } from '@profitfy/pakkun-icons';
import { useTheme } from 'styled-components/macro';
import { EHeadingSize, EHeadingWeight } from '@domain/enums/components/EHeading';
import { IPaytConfigProps } from '@domain/interfaces/dashboard/IntegrationCenter/InfoProduct/IPayt';

import CredentialOption from './CredentialOption';

import * as S from './styles';

const PaytConfig: React.FC<IPaytConfigProps> = ({ credentialAliasId }) => {
  const theme = useTheme();

  return (
    <S.ContentWrapper>
      <S.Header>
        <PaytIcon size={52} color={theme.colors.gray[2]} />
        <S.Heading type={EHeadingSize.H4} fontWeight={EHeadingWeight.REGULAR}>
          Integração com Payt
        </S.Heading>
      </S.Header>

      <CredentialOption credentialAliasId={credentialAliasId} />
    </S.ContentWrapper>
  );
};

export default PaytConfig;
